import { render, staticRenderFns } from "./dataGiveManage.vue?vue&type=template&id=13595fd4&scoped=true"
import script from "./dataGiveManage.vue?vue&type=script&lang=js"
export * from "./dataGiveManage.vue?vue&type=script&lang=js"
import style0 from "./dataGiveManage.vue?vue&type=style&index=0&id=13595fd4&prod&scoped=true&lang=css"
import style1 from "./dataGiveManage.vue?vue&type=style&index=1&id=13595fd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13595fd4",
  null
  
)

export default component.exports